import { yupResolver } from '@hookform/resolvers/yup';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { NavigateFunction, useNavigate, useSearchParams } from 'react-router-dom';
import { Seo } from '../../components/common/Seo';
import ErrorForm from '../../components/forms/ErrorForm';
import { connexionSchema, connexionType } from '../../schema/LoginSchema';
import UsersService from '../../services/users.service';
import DoubleAuthSmsModal from '../DashboardApps/DoubleAuthSmsModal';
import LoginForm from './forms/LoginForm';
import TFAForm from './forms/TFAForm';
import UpdateSkemeetPasswordForm from './forms/UpdateSkemeetPasswordForm';

type SkemeetUserInfos = {
  temporaryAccessToken: string;
  firstname: string;
  lastname: string;
  cellphone: string;
};

const LoginComponent = () => {
  const navigate: NavigateFunction = useNavigate();
  const searchQueryParams = useSearchParams()[0];
  const usersService = new UsersService();

  const [pageStep, setPageStep] = useState<string>('connexion');
  const [isDoubleAuthEmail, setIsDoubleAuthEmail] = useState<boolean>(false);
  const [skemeetUserInfos, setSkemeetUserInfos] = useState<SkemeetUserInfos>({
    temporaryAccessToken: '',
    firstname: '',
    lastname: '',
    cellphone: '',
  });
  const [isDoubleAuthModalOpen, setIsDoubleAuthModalOpen] = useState(false);

  const connexionMethods = useForm<connexionType>({
    resolver: yupResolver(connexionSchema),
    mode: 'onSubmit',
    defaultValues: {
      nickNameOrEmail: '',
      password: '',
    },
  });

  const redirect = async (check2FA: boolean = true) => {
    if (!check2FA) return;
    const { data: user } = await usersService.getUserData();
    if (user.doubleAuthEmailActivated) return setIsDoubleAuthModalOpen(true);

    const redirectUrl = searchQueryParams.get('redirectUrl');
    if (redirectUrl) {
      window.location.href = redirectUrl;
      return;
    }

    navigate('/dashboard/apps');
  };

  return (
    <>
      <div className='z-[10] w-full rounded-lg bg-white p-10'>
        {
          {
            connexion: (
              <LoginForm
                setPageStep={setPageStep}
                setSkemeetUserInfos={setSkemeetUserInfos}
                connexionMethods={connexionMethods}
                setIsDoubleAuthEmail={setIsDoubleAuthEmail}
                redirect={redirect}
              />
            ),
            connexionStepTwo: (
              <TFAForm
                setPageStep={setPageStep}
                connexionMethods={connexionMethods}
                setIsDoubleAuthEmail={setIsDoubleAuthEmail}
                isDoubleAuthEmail={isDoubleAuthEmail}
                redirect={redirect}
              />
            ),
            updateSkemeetPassword: (
              <UpdateSkemeetPasswordForm skemeetUserInfos={skemeetUserInfos} connexionMethods={connexionMethods} redirect={redirect} />
            ),
            error: <ErrorForm onClick={() => setPageStep('connexion')} />,
          }[pageStep]
        }
      </div>
      <Seo title={'Connexion'} />
      <DoubleAuthSmsModal
        isOpen={isDoubleAuthModalOpen}
        onClose={async () => {
          setIsDoubleAuthModalOpen(false);
          redirect(false);
        }}
      />
    </>
  );
};

export default LoginComponent;
